import React, { useEffect, useState } from 'react';
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useBusinessAuth } from '../context/BusinessContext';
import FormSupplierUpdate from '../../FrontEnd/Integration/FormSupplierUpdate';
import Spinner from '../../FrontEnd/Integration/Spinner';

export default function FbBusinessProfileUpdate() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const { user } = useBusinessAuth();

  useEffect(() => {
    if (!user) return;

    const load = async () => {
      try {
        setLoading(true);

        const snap = doc(db, 'supplier', user.uid);
        const ref = await getDoc(snap);

        if (ref.exists()) {
          setProfile({ id: ref.id, ...ref.data() });
        } else {
          setProfile({});
        }

      } catch (err) {
        console.error("Erro ao buscar perfil:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [user]);
console.log(profile)
  if (loading) return <Spinner />;

  if (!profile) return <p>Sem dados encontrados.</p>;

  return (
    <div>
      <FormSupplierUpdate company={profile} />
    </div>
  );
}